<mat-card class="mat-elevation-z0" style="margin-top: 10px">
  <div class="justify-content-between d-flex">
    <span class="address-text space-left space-bottom">
      {{ typeTranslation }}
    </span>
  </div>

  <div class="d-flex">
    <div class="flexer">
      <div class="space-left">
        <div class="space-bottom">
          <div>
            <span
              *ngIf="inputOtherProduct.otherProductMaterial?.length > 0"
              class="preserve-line-break display-contents"
            >
              <span class="font-weight-bold inline-flex">Materiaal: </span>
              {{ inputOtherProduct.otherProductMaterial }}
            </span>

            <span
              *ngIf="
                inputOtherProduct.otherProductMaterial == null ||
                inputOtherProduct.otherProductMaterial.length === 0
              "
            >
              <span class="font-weight-bold">Materiaal: </span>
              Geen informatie
            </span>
          </div>

          <div>
            <span class="font-weight-bold">Afmetingen: </span>
            {{ inputOtherProduct.height ? inputOtherProduct.height : '0' }} cm h
            x {{ inputOtherProduct.width ? inputOtherProduct.width : '0' }} cm b
          </div>

          <div
            *ngIf="
              inputOtherProduct.layoutDescription != null &&
              inputOtherProduct.layoutDescription.length > 0
            "
          >
            <span class="preserve-line-break display-contents">
              <span class="font-weight-bold inline-flex">Extra info: </span>
              {{ inputOtherProduct.layoutDescription }}
            </span>
          </div>
        </div>

        <div class="space-bottom">
          <div class="font-weight-bold">Ontwerp:</div>

          <span *ngIf="inputOtherProduct.newDesign">
            De klant levert het ontwerp aan
          </span>

          <span
            *ngIf="
              inputOtherProduct.newDesign != null &&
              !inputOtherProduct.newDesign
            "
          >
            Inpress maakt het ontwerp aan
          </span>

          <div
            *ngIf="inputOtherProduct.generalExtraInfo != null"
            class="upper-space"
          >
            <span class="preserve-line-break">
              {{ inputOtherProduct.generalExtraInfo }}
            </span>
          </div>
        </div>

        <div>
          <ul>
            <li>
              <span>Titel:</span>

              <span class="strong">
                &nbsp;{{ getTitle(inputOtherProduct.title) }}
              </span>
            </li>

            <li>
              <span class="preserve-line-break display-contents">
                <span>{{ multiplePhoneNumbers ? 'Telnrs:' : 'Telnr:' }}</span>

                <span
                  *ngFor="
                    let group of productPhoneNumberGroups;
                    let last = last;
                    trackBy: trackById
                  "
                >
                  <span
                    class="strong"
                    *ngIf="productPhoneNumberGroups.length > 1"
                  >
                    {{ group.companyName }}:
                  </span>

                  <span
                    *ngFor="
                      let phoneNumber of group.phoneNumbers;
                      let ilast = last
                    "
                  >
                    <a class="click-link strong" href="tel:{{ phoneNumber }}">
                      &nbsp;{{ phoneNumber }}
                    </a>

                    <span class="strong">
                      {{ !ilast && group.phoneNumbers.length > 1 ? ',' : '' }}
                    </span>
                  </span>

                  <span class="strong">
                    {{
                      !last && productPhoneNumberGroups.length > 1 ? ' / ' : ''
                    }}
                  </span>
                </span>

                <span
                  class="strong"
                  *ngIf="productPhoneNumberGroups.length === 0"
                >
                  Geen telefoonnummers
                </span>
              </span>
            </li>

            <li>
              <span class="preserve-line-break display-contents">
                <span>Tekst: </span>

                <span class="inline-flex">
                  {{
                    inputOtherProduct.text == null ||
                    inputOtherProduct.text === ''
                      ? 'Geen tekst'
                      : inputOtherProduct.text
                  }}
                </span>
              </span>
            </li>

            <li *ngIf="inputOtherProduct.immoscoopLogo != null">
              <img
                src="/assets/{{
                  inputOtherProduct.immoscoopLogo
                    ? 'immoscoop_banner'
                    : 'immoscoop_banner_kruis'
                }}.png"
                class="immoscoop-logo"
              />
            </li>

            <li *ngIf="inputOtherProduct.spottoLogo != null">
              <img
                src="/assets/{{
                  inputOtherProduct.spottoLogo
                    ? 'spotto_banner'
                    : 'spotto_banner_kruis'
                }}.png"
                class="spotto-logo"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="flexer">
      <div class="d-flex images">
        <div *ngFor="let item of inputOtherProduct.productAssets; index as i">
          <div
            *ngIf="
              (item?.archived === false || client) &&
              (item?.formSection === 'otherDesign' ||
                item?.formSection === 'internalDesign')
            "
            class="loadedImg align-middle"
            matTooltip="{{ item?.asset?.name }}"
          >
            <div class="d-flex box click-link" class="max-summary-width">
              <a
                download="{{ item.asset.name }}"
                href="/api/assets/{{ item.asset.uuid }}"
                style="margin-right: 7px"
                class="d-flex box"
              >
                <div class="filename">
                  {{ item?.asset?.name | shortenTextSplitOn : '.' : 10 }}
                </div>

                <a>
                  <mat-icon aria-hidden="false" aria-label="remove">
                    cloud_download
                  </mat-icon>
                </a>
              </a>
            </div>

            <a
              class="click-link"
              href="/api/assets/{{ item.asset.uuid }}"
              *ngIf="isImage(item.asset)"
              data-lightbox="product"
            >
              <img
                *ngIf="isImage(item.asset)"
                class="max-summary-width max-summary-height"
                src="/api/assets/{{ item.asset.uuid }}"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-card>
